import React from 'react';
import './strikethrough-header.scss';
function StrikeThroughHeader({ id, className, children }) {
  return (
    <div className={'strikethrough-header' + (className ? ' ' + className : '')} id={id}>
      <h3>{children}</h3>
    </div>
  );
}

export { StrikeThroughHeader };
